module.exports = __webpack_public_path__ + "img/panoptic_ai.be8fe108.svg";